import { EnvironmentParams } from './environment-params';

const region = 'eu-west-1';
const stage = 'staging';
const loginId = `61u17rycz6`;
const apiId = `i67dsbfasa`;
const userAdminId = `8lf2mnpzyl`;
const organisationAdminId = `cf7but6jpa`;
const listingAdminId = `3vogxngi24`;
const eventAdminId = `t0uhuwmrxj`;
const retiredUserAdminId = `kt6j7fce2m`;
const financeAdminId = `a9kgs19f4b`;
const notificationAdminId = 'z7217mr4m2';
const branchAdminId = 'eb7g30iz79';

export const environment: EnvironmentParams = {
  region,
  production: false,
  loginUrl: `https://${loginId}.execute-api.${region}.amazonaws.com`,
  apiUrl: `https://${apiId}.execute-api.${region}.amazonaws.com/${stage}`,
  userAdminUrl: `https://${userAdminId}.execute-api.${region}.amazonaws.com/${stage}`,
  organisationAdminUrl: `https://${organisationAdminId}.execute-api.${region}.amazonaws.com/${stage}`,
  listingAdminUrl: `https://${listingAdminId}.execute-api.${region}.amazonaws.com/${stage}`,
  eventAdminUrl: `https://${eventAdminId}.execute-api.${region}.amazonaws.com/${stage}`,
  retiredUserAdminUrl: `https://${retiredUserAdminId}.execute-api.${region}.amazonaws.com/${stage}`,
  financeAdminUrl: `https://${financeAdminId}.execute-api.${region}.amazonaws.com/${stage}`,
  adminUrl: `https://${apiId}.execute-api.${region}.amazonaws.com/${stage}`,
  notificationAdminUrl: `https://${notificationAdminId}.execute-api.${region}.amazonaws.com/${stage}`,
  branchAdminUrl: `https://${branchAdminId}.execute-api.${region}.amazonaws.com/${stage}`,
  leisureUrl: `https://${stage}.partnerchoice.co.uk`,
  cloudFrontDomainName: `https://dj7k0uqtuiix9.cloudfront.net`,
  features: {
    auditLog: {
      active: true,
      description: 'Displays log messages for a listing.',
    },
    eventTickets: { active: true, description: 'Upload event tickets.' },
  },
  AuthConfig: {
    discoveryUrl:
      'https://jlp-logon-acpt.johnlewis.co.uk/.well-known/openid-configuration',
    clientId: 'PartnerChoice',
    redirectUri: '',
    scope: 'openid profile email',
    audience: '',
    refreshUrl: 'https://jlp-logon-acpt.johnlewis.co.uk/as/token.oauth2',
  },
  verboseLogging: true,
};
